import { Record } from 'immutable';
import {
  RecordingRequestObjectSort,
  RecordingRequestObjectTimeLine
} from 'constants/recordingsConstants';
import { Recording, UploadStatusResponse } from 'interfaces/Recording';

export interface RecordingsInterface extends Recording {
  isGridLayout: boolean;
  pageNum: number;
  searchResults: Array<object>;
  sortBy: RecordingRequestObjectSort;
  timeline: RecordingRequestObjectTimeLine;
  pending: boolean;
  meeting: string | undefined;
  meetingName: string;
  uploadsStatus: UploadStatusResponse[];
}

export const initialState: RecordingsInterface = {
  isFetching: false,
  isGridLayout: true,
  pageNum: 1,
  recordingData: null,
  searchResults: [],
  pending: false,
  meeting: undefined,
  meetingName: '',
  sortBy: RecordingRequestObjectSort.SORT_DATE,
  timeline: RecordingRequestObjectTimeLine.TIMELINE_ANY,
  uploadsStatus: []
};

export default class RecordingsState extends Record(initialState) {
}
